import { Injectable, signal } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { BidDetailsSidebarView } from '../models/bid-details-sidebar.type';

/**
 * Manages the bid-details sidebar state at a global level so that the
 * sidebar can render outside stacking contexts (e.g. mat-tab-body).
 */
@Injectable({ providedIn: 'root' })
export class BidDetailsSidebarService {
  readonly isOpen = signal(false);
  readonly data = signal<BidDetailsSidebarView | null>(null);
  readonly chatOpenRequest = signal<{ bidId: string; nonce: number } | null>(null);

  private readonly _approveBid$ = new Subject<string>();
  readonly approveBid$: Observable<string> = this._approveBid$.asObservable();

  open(sidebarData: BidDetailsSidebarView): void {
    this.data.set(sidebarData);
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
    this.data.set(null);
    this.chatOpenRequest.set(null);
  }

  updateData(sidebarData: BidDetailsSidebarView): void {
    this.data.set(sidebarData);
  }

  emitApproveBid(bidId: string): void {
    this._approveBid$.next(bidId);
  }

  requestChatOpen(bidId: string): void {
    this.chatOpenRequest.set({ bidId, nonce: Date.now() });
  }

  clearChatOpenRequest(): void {
    this.chatOpenRequest.set(null);
  }
}
